import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Dziękujemy, {{name}}',
    confirmation_email:
      'Wkrótce otrzymasz e-mail potwierdzający z numerem zamówienia od naszego partnera technologicznego {{provider_email}}',
    need_help: 'Potrzebujesz pomocy?',
  },
  labels: {
    order_number: 'Nr zamówienia: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Dzisiaj',
    was_prefix: 'było',
    restaurant: 'Restauracja',
    order_details: 'Szczegóły zamówienia',
    your_details: 'Twoje dane',
    contact: 'Kontakt',
    payment: 'Płatność',
    payment_method: 'Metoda płatności',
    delivery: 'Dostawa',
    delivery_details: 'Szczegóły dostawy',
    pickup_details: 'Szczegóły odbioru',
    pickup_instruction: '📋 Podaj numer zamówienia {{number}} przy odbiorze.',
    billing_info: 'Dane do faktury',
    order_note: 'Notatka do zamówienia',
    order_summary: 'Podsumowanie zamówienia',
    help: 'Potrzebujesz pomocy? Skontaktuj się z nami {{phone_number}}',
  },
  status: {
    canceled: 'Zamówienie anulowane',
    received: 'Zamówienie przyjęte',
    confirmed: 'Zamówienie potwierdzone!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Odbiór',
    [ORDER_METHODS.DELIVERY]: 'Dostawa',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Obsługa pokoju',
      [RoomServiceLocationType.TableService]: 'Obsługa przy stoliku',
    },
  },
  room_service_details: {
    [RoomServiceLocationType.RoomService]: '(pokój #{{details}})',
    [RoomServiceLocationType.TableService]: '(stolik #{{details}})',
  },
  rewards: {
    member: {
      pill_title: 'Zdobyte punkty',
      from_order: 'punkty z tego zamówienia',
      total_balance: 'Saldo łączne',
      reward_value: 'Wartość nagrody',
      redeem_hint: '✓ Możesz wymienić do {{points}} pkt ({{amount}}) przy następnym zamówieniu',
      points_to_redeem: 'Potrzebujesz jeszcze {{points}} pkt, aby zrealizować nagrodę',
    },
    guest: {
      pill_title: 'Nagrody',
      earned_heading: 'Zarobiłeś <highlight>{{points}} punktów</highlight> za to zamówienie',
      worth_on_next: 'Warte <strong>{{amount}}</strong> przy następnym zamówieniu',
      ready_to_claim: 'Gotowe do odebrania',
      next_order_discount: 'Rabat na następne zamówienie',
      claim_cta: 'Odbierz swoje {{points}} pkt — zarejestruj się bezpłatnie',
      claim_note: 'Zajmuje 30 sekund · punkty są naliczane natychmiast',
    },
  },
  buttons: {
    back_to_menu: 'Wróć do menu',
    back_to_checkout: 'Wróć do kasy',
    contact_us: 'Skontaktuj się z nami {{phone_number}}',
    try_again: 'Spróbuj ponownie',
  },
  loading: {
    processing_payment: 'Nie opuszczaj strony, dopóki przetwarzamy Twoją płatność',
  },
  success_messages: {
    order_placed: {
      title: '✅ Zamówienie złożone!',
      description: 'Twoje zamówienie zostało złożone pomyślnie.',
    },
  },
  error_messages: {
    failed_to_load: 'Nie udało się wczytać zamówienia. Spróbuj ponownie.',
    payment_failed: 'Płatność nie powiodła się, spróbuj ponownie',
  },
  load_failed: {
    title: 'Nie udało się załadować Twojego zamówienia',
    description:
      'Coś poszło nie tak podczas wczytywania szczegółów Twojego zamówienia. Spróbuj ponownie. Jeśli problem będzie się powtarzał, skontaktuj się z pomocą techniczną, a od razu Ci pomożemy.',
  },
};
